var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [_c("header-login"), _vm._v(" "), _vm._m(0)],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("main", { staticClass: "registerScreen" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row --mainRow" }, [
          _c("div", {
            staticClass:
              "col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol"
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-12 col-lg-12 col-xl-6 rightCol" },
            [
              _c("div", { staticClass: "paddingBox" }, [
                _c("h2", [_vm._v("Registrácia")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                            Ďakujeme za váš záujem zaregistrovať triedu vašej základnej školy alebo škôlky do školskej súťaže Adoptuj kravičku o hodnotné ceny.\n                            Registrácia bude spustená 1.9.2021.\n                        "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Sledujte náš "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.facebook.com/AdoptujKravicku",
                        target: "_blank"
                      }
                    },
                    [_vm._v("facebookový účet")]
                  ),
                  _vm._v(" pre viac informácií.")
                ])
              ])
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }